import { Box, Stack, Typography } from '@mui/material';
import { isNil } from 'lodash';

import { MAX_BATTERY_LEVEL, useDeviceBatteryStatus } from '@/api/devices';
import { AlertChip } from '@/components/AlertChip';
import { DotLevelIndicator } from '@/components/data/DotLevelIndicator';
import { IconData } from '@/components/data/IconData';
import { BatteryVoltageSection } from '@/components/spotter/statusTab/BatteryVoltageSection';
import { useSpotterContext } from '@/context/SpotterContext';

const BatteryStatusSection = () => {
    const { spotterId } = useSpotterContext();
    const { data: batteryStatus } = useDeviceBatteryStatus({ spotterId });

    return (
        batteryStatus && (
            <IconData
                variant="wide"
                Icon={batteryStatus.StatusIcon}
                label="Battery status"
                labelProps={{ variant: 'h5', mb: 2 }}
                timestamp={batteryStatus.timestamp}
            >
                <Stack direction="row" alignItems="center" gap={2}>
                    {!isNil(batteryStatus?.level) && (
                        <DotLevelIndicator
                            level={batteryStatus.level}
                            maxLevel={MAX_BATTERY_LEVEL}
                            color={batteryStatus.color}
                        />
                    )}
                    {batteryStatus.error && <AlertChip severity="error" label={batteryStatus.error.description} />}
                </Stack>
            </IconData>
        )
    );
};

export const BATTERY_SECTION_ID = 'battery-section';

export const BatterySection = () => {
    const border = '1px solid rgba(192, 192, 192, 0.8)';

    return (
        <Stack id={BATTERY_SECTION_ID}>
            <Typography variant="h4" mb={2}>
                Battery
            </Typography>
            <Box sx={{ border, p: 3 }}>
                <BatteryStatusSection />
            </Box>
            <Box sx={{ border, borderTop: 'none' }}>
                <BatteryVoltageSection />
            </Box>
        </Stack>
    );
};
